/**
 * After-add behaviour for the cart-page model (no drawer), plus the shared
 * toast (.ds-toast in design-system.css).
 *
 * Reads window.cartConfig.afterAdd:
 *   - "cart"  (default): navigate to the full cart page after a successful add.
 *   - "toast": show a slim, non-blocking confirmation and stay on the page.
 *
 * Every add-to-cart entry point (product form, Travel & Storage, edit drawer)
 * calls window.IceboxAfterAdd.handle() so the behaviour is defined in exactly
 * one place and is trivial to flip for an A/B test.
 * window.IceboxToast.show(message, { href, label }) shows any short status.
 */
(function () {
  function mode() {
    return (window.cartConfig && window.cartConfig.afterAdd) || 'cart';
  }

  function cartUrl() {
    return (window.cartConfig && window.cartConfig.cartUrl) || (window.routes && window.routes.cart_url) || '/cart';
  }

  function onCartPage() {
    return !!document.querySelector('cart-items');
  }

  // On the stay-on-page path nothing else refreshes the header count, so
  // update the bubble ourselves (skipped where there is no bubble, e.g. /cart).
  function updateCartIcon() {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    fetch(`${cartUrl()}?sections=cart-icon-bubble`)
      .then((r) => r.json())
      .then((data) => {
        const html = data && data['cart-icon-bubble'];
        if (!html) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const source = parsed.querySelector('.shopify-section');
        if (source) bubble.innerHTML = source.innerHTML;
      })
      .catch(() => {});
  }

  let toastTimer = null;

  function showToast(message, options) {
    const opts = options || {};
    let toast = document.getElementById('CartToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'CartToast';
      toast.className = 'ds-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');

      const text = document.createElement('p');
      text.className = 'ds-toast__text';

      const link = document.createElement('a');
      link.className = 'ds-toast__link';

      toast.append(text, link);
      document.body.appendChild(toast);
    }

    toast.querySelector('.ds-toast__text').textContent = message;
    const link = toast.querySelector('.ds-toast__link');
    link.hidden = !opts.href;
    if (opts.href) {
      link.href = opts.href;
      link.textContent = opts.label || 'View';
    }

    void toast.offsetWidth;
    toast.classList.add('is-visible');

    if (toastTimer) window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
  }

  window.IceboxToast = { show: showToast };

  window.IceboxAfterAdd = {
    mode,
    /**
     * @param {object} [options]
     * @param {boolean} [options.navigateAllowed=true] set false when the caller
     *   cannot tolerate a navigation (e.g. the cart page itself); toast is used instead.
     */
    handle(options) {
      const opts = options || {};
      if (mode() === 'toast' || opts.navigateAllowed === false || onCartPage()) {
        updateCartIcon();
        if (onCartPage()) showToast('Added to your bag');
        else showToast('Added to your bag', { href: cartUrl(), label: 'View bag' });
        return false;
      }
      window.location.assign(cartUrl());
      return true;
    },
  };
})();
